// Display helper for SOW number references in milestone surfaces.
// `Sow.number` round-trips one of two contract-configured formats:
//   - "nn"            → "01"           (bare digits)
//   - "sow-yyyy-nnn"  → "SOW-2026-001" (already prefixed)
// On milestone surfaces a bare "01" is ambiguous (could be a year, a
// sequence number, anything), so we synthesise a "SOW" prefix when one
// isn't already present. The prefixed form ("SOW01" / "SOW-2026-001")
// always reads as a SOW reference at a glance.

export function formatSowDisplayNumber(sowNumber: string): string {
  return /^sow/i.test(sowNumber) ? sowNumber : `SOW${sowNumber}`;
}
